import Controller from '../abstracts/Controller';
import 'scss-templates/t-myaccount-return-confirm.scss';


/**
 * Controller for page MyAccount Orders
 */
export default class MyAccountOrdersReturnSummaryController extends Controller {
  static get COMPONENTS(){
    return [
      'PreventDoubleClickComponent',
      'DataLinkHrefComponent',
      'RegistrationComponent'
    ];
  }

}
